import React from "react";
import { 
  FaCogs, FaFileAlt, FaDatabase, 
  FaLink, FaTerminal, FaCode 
} from 'react-icons/fa';
import "./TallyDefinition.css";

function TallyDefinition() {
  return (
    <div className="tdl-page-wrapper">
      {/* ── Hero Section ── */}
      <header className="tdl-hero">
        <div className="tdl-hero-content">
          <h1>Tally Definition Language</h1>
          <p>
            The technology backbone for TallyPrime. A powerful, platform-independent 
            language designed for rapid development and seamless integration.
          </p>
        </div>
      </header>

      {/* ── Narrative Row ── */}
      <section className="tdl-narrative-section">
        <div className="tdl-row">
          <div className="tdl-text">
            <h2>The Heart of Tally</h2>
            <p>
              TDL forms the key link between the application and the platform layer. 
              It provides users with the power to extend default capabilities and 
              integrate with external applications effortlessly.
            </p>
            <p>
              Coupled with the TallyPrime Developer suite, TDL enables rapid rendering, 
              sophisticated data management, and complex cross-platform solutions 
              that grow with your business.
            </p>
          </div>
          <div className="tdl-visual">
            <div className="tdl-visual-container">
              <img 
                src="/images/tally/deploy-link-tdl-configuration-with-account-tally.gif" 
                alt="TDL Technology Stack" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── Capabilities Grid ── */}
      <section className="tdl-capabilities-section">
        <div className="capabilities-header">
          <h2>Core Capabilities</h2>
        </div>
        <div className="capabilities-grid">
          <CapabilityCard 
            icon={<FaCogs />}
            title="Customizability"
            text="Platform-independent programming that ensures your solutions remain consistent across all operating systems and network environments."
          />
          <CapabilityCard 
            icon={<FaFileAlt />}
            title="Multiple Outputs"
            text="Generate output for screen, print, files, or even web protocols like HTTP with a single definition logic."
          />
          <CapabilityCard 
            icon={<FaDatabase />}
            title="Data Management"
            text="Manipulate internal Tally objects with ease, enabling sophisticated data storage and retrieval tailored to your needs."
          />
          <CapabilityCard 
            icon={<FaLink />}
            title="Integrate-ability"
            text="Extensive hooks and protocols that allow the developer community to deliver high-performance cross-platform solutions."
          />
        </div>
      </section>

      {/* ── Developer Love Section ── */}
      <section className="developer-experience-section">
        <div className="dev-love-card">
          <div className="dev-love-header">
            <h2>Why Programmers Love TDL</h2>
          </div>
          <div className="dev-love-text">
            <p>
              TallyPrime Developer simplifies a programmer’s life with a feature-rich 
              environment. Enjoy powerful search engines, syntax highlighting, 
              auto-completion, and column selection. 
            </p>
            <p style={{marginTop: '20px'}}>
              <FaTerminal style={{marginRight: '10px'}} />
              Handle multiple projects, navigate across complex definitions, 
              and debug code with a high-performance editor built for efficiency.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

const CapabilityCard = ({ icon, title, text }) => {
  return (
    <div className="capability-card">
      <div className="capability-icon">{icon}</div>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
};

export default TallyDefinition;
